import { useEffect, useMemo, useState } from "react";
import Aside from "../../../components/Aside"
import CustomDataTable from "../../../components/CustomDataTable";
import Footer from "../../../components/Footer"
import Header from "../../../components/Header"
import { ReportService } from "../../../services/ReportsService";
import { useCurrentAccount } from "../../../hooks/useCurrentAccount";
import { DateUtil } from "../../../utils/date";
import { NumberUtil } from "../../../utils/number";
import Tooltip from "../../../components/Tooltip";
import DetailCategoriesModal from "./DetailCategoriesModal";
import { ColorUtil } from "../../../utils/color"
import * as XLSX from 'xlsx';
import { AlertService } from "../../../services/Alert";
import { useTranslation } from "react-i18next";
import useRequest from "../../../hooks/useRequest";
import LoaderSmall from "../../../components/LoaderSmall";
import usePermission from "../../../hooks/usePermission";
import PieChart from "../../../components/PieChart";
import FullPieChart from "../../../components/FullPieChart"

function ReportAgentsPage() {

    const { t } = useTranslation();
    const { call, isRequesting } = useRequest();
    const { account } = useCurrentAccount();
    const hasDownloadAccess = usePermission('reports.download');
    const [fullPieChartData, setFullPieChartData] = useState({ show: false, data: [], dataChart: [], title: '' })
    const [header, setHeader] = useState({
        avg_hours: "00:00:00",
        total_tt: 0,
        total_tt_abanoned: 0,
        total_tt_out_response: 0,
        total_tt_resolve: 0,
    })
    const [modal, setModal] = useState({
        show: false,
        data: null
    })
    const [data, setData] = useState([])
    const [filterRangeDates, setFilterRangeDates] = useState({ start: null, end: null })

    const columns = [
        {
            name: t("reports.agents.agent"),
            sortable: true,
            selector: row => row.user,
        },
        {
            name: t("reports.agents.session"),
            sortable: false,
            center: true,
            cell: (row: any) => {
                let resume = {};
                const keys = Object.keys(row.session_chart);
                const totalSegundos = keys.reduce((acc, k) => acc + row.session_chart[k], 0);

                keys.forEach(k => {
                    const porcentaje = ((row.session_chart[k] / totalSegundos) * 100).toFixed(2);
                    resume[k] = {
                        label: k,
                        total: porcentaje,
                        color: ColorUtil.stringToRGB(k),
                    };
                });

                const labels = keys.map(k => resume[k].label);
                const data = keys.map(k => resume[k].total);
                const backgroundColor = keys.map(k => resume[k].color);

                return (
                    <div className="d-flex" style={{ marginLeft: '3rem', marginRight: '3rem' }}>
                        <div className="flex-grow-1">
                            <div>
                                <PieChart
                                    datasetName="Porcentaje"
                                    dataset={{
                                        labels,
                                        data,
                                        backgroundColor,
                                    }}
                                />
                            </div>
                        </div>
                        <span className="icon bg-soft-info-alternative  text-info-alternative icon-sm icon-circle ms-3">
                            <Tooltip title={t("reports.agents.tooltip")} className="d-grid gap-2">
                                <button
                                    title="chart"
                                    type="button"
                                    className="btn btn-link"
                                    onClick={() => {
                                        const dataInHHMM = keys.map((c) => {
                                            const totalSeconds = row.session_chart[c];
                                            const hours = Math.floor(totalSeconds / 3600);
                                            const minutes = Math.floor((totalSeconds % 3600) / 60);

                                            let value = '';
                                            if (hours > 0) {
                                                value = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')} hrs`;
                                            } else if (minutes > 0) {
                                                value = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')} min`;
                                            } else {
                                                value = `00:00`;
                                            }

                                            return {
                                                label: c,
                                                value,
                                            };
                                        });

                                        setFullPieChartData({
                                            title: t("reports.agents.session"),
                                            show: true,
                                            data: dataInHHMM,
                                            dataChart: data,
                                        });
                                    }}



                                >
                                    <i className="bi bi-arrows-fullscreen"></i>
                                </button>
                            </Tooltip>
                        </span>
                    </div>
                );
            },
        },
        {
            name: t("reports.agents.working-hours"),
            sortable: true,
            selector: row => DateUtil.formatTime(row.hrs_session),
        },
        {
            name: t("reports.agents.resolved"),
            sortable: true,
            selector: row => NumberUtil.format(row.tt_resolve),
        },
        {
            name: t("reports.agents.tickets-abandoned-customer"),
            sortable: true,
            selector: row => NumberUtil.format(row.tt_abandoned),
        },
        {
            name: t("reports.agents.tickets-no-response"),
            sortable: true,
            selector: row => NumberUtil.format(row.tt_out_response),
        },
        {
            name: t("reports.agents.closure"),
            sortable: false,
            center: false,
            cell: (row) => {
                let tipications = row.tipications;

                let keys = Object.keys(tipications)

                let array = keys.map(k => ({ category: k, total: tipications[k] })).sort((a, b) => b.total - a.total)

                let first = array.slice(0, 3)

                return (
                    <div className="text-start">
                        {first.map((row, i) => <p key={i} ><span className={`legend-indicator bg-primary ${i === 1 ? 'opacity-50' : i === 2 ? 'opacity-25' : ''}`}></span> {row.category}: {row.total}</p>)}

                        {
                            array.length > 3 && (
                                <div className="" onClick={() => setModal({ data: row, show: true })}>
                                    <Tooltip title={t("reports.agents.tooltip")} className="d-grid gap-2">
                                        <button className="btn badge bg-soft-dark text-dark link-underline">
                                            +{array.length - 3} categorías
                                        </button>
                                    </Tooltip>
                                </div>
                            )
                        }

                    </div>
                )


                // return  (
                //     <PieChart 
                //         datasetName='Resumen'
                //         width={350}
                //         dataset={{
                //             labels: ['WhatsApp Business','SMS','No enviado'],
                //             data: [row.resume_send.wa,row.resume_send.sms, row.resume_send.not_send],
                //             backgroundColor: ['#52ce60', '#4080ee', '#ed4c78'],
                //         }}
                //     />
                // )
            }
        },

    ];

    const exportToExcel = () => {
        const HEADER = [
            'AGENTE',
            'HORAS DE TRABAJO',
            'TICKETS RESUELTOS',
            'TICKETS ABANDONAMOS POR CLIENTE',
            'TICKETS SIN RESPUESTA DE AGENTE',
            'CATEGORÍAS DE CIERRE',
        ];

        const dynamicHeaders = Array.from(
            new Set(data.flatMap(row => Object.keys(row.session_data || {})))
        ).map(header => (header === 'online_time' ? 'TIEMPO EN LINEA' : header));

        const updatedHeader = [...HEADER, ...dynamicHeaders];

        const rows = data.map(row => {
            const tipications = row.tipications || {};
            const keys = Object.keys(tipications);

            const categories = keys
                .map(k => ({ category: k, total: tipications[k] }))
                .sort((a, b) => b.total - a.total)
                .map(k => `${k.category}: ${k.total}`)
                .join('\n');

            const baseRow = {
                'AGENTE': row.user,
                'HORAS DE TRABAJO': DateUtil.formatTime(row.hrs_session),
                'TICKETS RESUELTOS': NumberUtil.format(row.tt_resolve),
                'TICKETS ABANDONAMOS POR CLIENTE': NumberUtil.format(row.tt_abandoned),
                'TICKETS SIN RESPUESTA DE AGENTE': NumberUtil.format(row.tt_out_response),
                'CATEGORÍAS DE CIERRE': categories,
            };
            dynamicHeaders.forEach(header => {
                const originalKey = header === 'TIEMPO EN LINEA' ? 'online_time' : header;
                baseRow[header] = row.session_data?.[originalKey] || '';
            });

            return baseRow;
        });

        const wb = XLSX.utils.book_new();

        const ws = XLSX.utils.json_to_sheet(rows, {
            header: updatedHeader,
        });

        XLSX.utils.book_append_sheet(wb, ws);

        return XLSX.writeFile(wb, `${new Date().getTime()}.xlsx`);
    };

    const exportToExcelPerDay = async () => {

        const promise = async () => {
            const start = filterRangeDates.start.format('YYYY-MM-DD')
            const end = filterRangeDates.end.format('YYYY-MM-DD')
            const data = await ReportService.getReportAgentsPerDay(account.id, start, end);

            const link = document.createElement('a');
            let csv = data;
            if (csv == null) return;

            const filename = `${new Date().getTime()}.csv`;

            if (!csv.match(/^data:text\/csv/i)) {
                csv = `data:text/csv;charset=utf-8,${csv}`;
            }

            link.setAttribute('href', encodeURI(csv));
            link.setAttribute('download', filename);
            link.click();
        }

        AlertService.toastLoading(promise(), 'Creando reporte...', 'Se generó correctamente el reporte', 'Ocurrió un error al generar el reporte, intenta nuevamente')
    }

    const getReport = async () => {

        if (filterRangeDates.start && filterRangeDates.end) {
            const start = filterRangeDates.start.format('YYYY-MM-DD')
            const end = filterRangeDates.end.format('YYYY-MM-DD')

            const { data } = await call(() => ReportService.getReportAgents(account.id, start, end));
            setHeader(Object.assign(header, data.accountants))
            setData(data.data)
        }
    }

    useEffect(() => {
        getReport()
    }, [filterRangeDates])
    const heightRequesting = useMemo(() => { return isRequesting ? 'mt-50 mb-50' : '' }, [isRequesting]);
    return (
        <>
            <Header />
            <Aside />

            <main id="content" role="main" className="main">

                <div className="content container-fluid">

                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-sm mb-2 mb-sm-0">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb breadcrumb-no-gutter">
                                        <li className="breadcrumb-item "><span className="breadcrumb-link" >{t("reports.operation-title")}</span></li>
                                        <li className="breadcrumb-item " aria-current="page">{t("reports.reports-title")}</li>
                                        <li className="breadcrumb-item active" aria-current="page">{t("reports.agents.agent-title")}</li>
                                    </ol>
                                </nav>
                                <h1 className="page-header-title text-white-dark"><i className="bi-grid-1x2-fill text-primary fw-bold nav-icon"></i> {t("reports.reports-title")} - {t("reports.agents.agent-title")}</h1>
                            </div>
                            {
                                hasDownloadAccess ?
                                    <div className="col-sm-auto">
                                        <div className="dropdown">
                                            <button className="btn btn-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                                                <i className="bi bi-download me-2"></i> {t("reports.agents.download")}
                                            </button>
                                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                <button className="dropdown-item" onClick={exportToExcel}>
                                                    {t("reports.agents.overview")}
                                                </button>
                                                <button className="dropdown-item" onClick={exportToExcelPerDay} >
                                                    {t("reports.agents.daily")}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    : null
                            }
                        </div>
                    </div>

                    <div className=" mb-3 mb-lg-5 ">
                        <div className={`row gx-lg-6 relative ${heightRequesting}`}>
                            {
                                isRequesting ? <LoaderSmall /> :
                                    <>
                                        <div className="col-lg-3 mb-md-3 mb-3">
                                            <div className="card card-sm">
                                                <div className="card-body">
                                                    <div className="d-flex">
                                                        <div className="flex-grow-1">
                                                            <h6 className="card-subtitle mb-3">{t("reports.agents.average-work")}</h6>
                                                            <h1 className="card-title">{DateUtil.formatTime(header.avg_hours)}</h1>

                                                        </div>

                                                        <span className="icon bg-soft-info-alternative  text-info-alternative icon-sm icon-circle">
                                                            <i className="bi-person-workspace"></i>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div className="col-lg-3 mb-md-3 mb-3">
                                            <div className="card card-sm">
                                                <div className="card-body">
                                                    <div className="d-flex">
                                                        <div className="flex-grow-1">
                                                            <h6 className="card-subtitle mb-3">{t("reports.agents.solved-tickets")}</h6>
                                                            <h1 className="card-title">{NumberUtil.format(header.total_tt_resolve)}</h1>

                                                        </div>

                                                        <span className="icon bg-soft-info-alternative  text-info-alternative icon-sm icon-circle ms-3">
                                                            <i className="bi-clipboard-check-fill"></i>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div className="col-lg-3 mb-md-3 mb-3">
                                            <div className="card card-sm">
                                                <div className="card-body">
                                                    <div className="d-flex">
                                                        <div className="flex-grow-1">
                                                            <h6 className="card-subtitle mb-3">{t("reports.agents.abandoned-tickets")}</h6>
                                                            <h1 className="card-title">{NumberUtil.format(header.total_tt_abanoned)}</h1>

                                                        </div>

                                                        <span className="icon bg-soft-info-alternative  text-info-alternative icon-sm icon-circle ms-3">
                                                            <i className="bi-clipboard-x-fill"></i>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-lg-3">
                                            <div className="card card-sm">
                                                <div className="card-body">
                                                    <div className="d-flex">
                                                        <div className="flex-grow-1">
                                                            <h6 className="card-subtitle mb-3">{t("reports.agents.no-answer-tickets")}</h6>
                                                            <h1 className="card-title">{NumberUtil.format(header.total_tt_out_response)}</h1>

                                                        </div>

                                                        <span className="icon bg-soft-info-alternative  text-info-alternative icon-sm icon-circle ms-3">
                                                            <i className="bi-chat-square-dots-fill"></i>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                            }
                        </div>

                    </div>


                    <CustomDataTable
                        columns={columns}
                        showDates
                        data={data}
                        hideAccountsFilter
                        showExport={false}
                        isLoading={isRequesting}
                        onDatesChange={(range) => setFilterRangeDates(range)}
                        filter={(row, term) => {
                            if (!term) return true;

                            return (
                                `${row.user}`.match(new RegExp(`${term}`, 'i'))
                            )
                        }}
                    />

                </div>
                <Footer />
            </main>

            <DetailCategoriesModal
                show={modal.show}
                data={modal.data}
                onRequestClose={() => setModal({ ...modal, show: false })}
            />
            <FullPieChart
                show={fullPieChartData.show}
                data={fullPieChartData.data}
                dataChart={fullPieChartData.dataChart}
                title={fullPieChartData.title}
                icon={'stopwatch'}
                onRequestClose={() => setFullPieChartData({ show: false, data: [], dataChart: [], title: '' })}
            />
        </>
    )
}
export default ReportAgentsPage